import React, { FC } from "react";
import NcdcRequestProgress from "./NcdcRequestProgress";
import classNames from "classnames";
import { useForm } from "react-hook-form";

type Props = {
    page: number;
    getPage: (seq: number) => void;
    getData: (data: any) => void;
}

const NcdcRequestForm: FC<Props> = ({page, getPage, getData}) => {
    const goToPrev = () => {
        window.scrollTo(0, 0);
        getPage(page - 1);
    }

    const goToNext = () => {
        window.scrollTo(0, 0);
        getPage(page + 1);
    }

    const { register, handleSubmit } = useForm();
    const onSubmit = (data: any) => {
        window.scrollTo(0, 0);
        getPage(page + 1);
        getData(data);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>

        <div className={classNames('ncdc-request-form-wrapper', {'no-show': page !== 1})}>
            <div className={'ncdc-request-form'}>
                <div className={'common-form-header-wrapper'}>
                    <span className={'common-form-header-title'}>데이터 신청</span>
                    <div className={'common-form-header-circle'} />
                </div>
                <NcdcRequestProgress seq={page - 1} />
                <div className={'common-form-table-wrapper'}>
                    <div className={'common-form-table'}>
                        <div className={'common-form-table-header-wrapper'}>
                            <div className={'common-form-table-header-title'}>
                                신청인 정보
                            </div>
                            <div className={'common-form-table-header-alert'}>
                                * 필수사항입니다.
                            </div>
                        </div>
                        <div className={'common-form-table-body-wrapper'}>
                            <div className={'common-form-table-body'}>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        신청인 이름
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'} {...register("usrName")} />
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        전화번호
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'} {...register("usrTel")}/>
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        소속
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'} />
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        직무
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input type={'radio'} name={'duty'} value={'연구책임자'} /> 연구책임자
                                    <input className={'ml-10'} type={'radio'} name={'duty'} value={'연구원'} /> 연구원
                                    <input className={'ml-10'} type={'radio'} name={'duty'} value={'연구보조'} /> 연구보조
                                    <input className={'ml-10'} type={'radio'} name={'duty'} value={'기타'} /> 기타
                                    <input className={'common-form-input-text sm ml-10'} placeholder={'직접 입력'} />
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        직위
                                    </span>
                                    <input type={'radio'} name={'pstn'} value={'연구책임자'} /> 연구책임자
                                    <input className={'ml-10'} type={'radio'} name={'pstn'} value={'연구원'} /> 연구원
                                    <input className={'ml-10'} type={'radio'} name={'pstn'} value={'연구보조'} /> 연구보조
                                    <input className={'ml-10'} type={'radio'} name={'pstn'} value={'기타'} /> 기타
                                </label>
                                <label className={'last'}>
                                    <span className={'common-form-input-label'}>
                                        E-mail
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text md'} />
                                    <span> @ </span>
                                    <input className={'common-form-input-text sm'} />
                                    <select className={'common-form-input-select ml-10'}>
                                        <option value={'self'}>직접입력</option>
                                        <option value={'naver.com'}>naver.com</option>
                                        <option value={'kakao.com'}>kakao.com</option>
                                        <option value={'hanmail.net'}>hanmail.net</option>
                                    </select>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'common-form-table-wrapper'}>
                    <div className={'common-form-table'}>
                        <div className={'common-form-table-header-wrapper'}>
                            <div className={'common-form-table-header-title'}>
                                연구요약서
                            </div>
                        </div>
                        <div className={'common-form-table-body-wrapper'}>
                            <div className={'common-form-table-body'}>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        가명자료 활용목적
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input type={'radio'} name={'prps'} value={'과학적연구'} /> 과학적연구
                                    <input className={'ml-10'} type={'radio'} name={'prps'} value={'통계작성'} /> 통계작성
                                    <input className={'ml-10'} type={'radio'} name={'prps'} value={'공익적 기록보존'} /> 공익적 기록보존
                                </label>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        연구유형
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input type={'radio'} name={'type'} value={'학술연구'} /> 학술연구
                                    <input className={'ml-10'} type={'radio'} name={'type'} value={'정책연구'} /> 정책연구
                                    <input className={'ml-10'} type={'radio'} name={'type'} value={'학위논문'} /> 학위논문
                                    <input className={'ml-10'} type={'radio'} name={'type'} value={'기타'} /> 기타
                                    <input className={'common-form-input-text sm ml-10'} placeholder={'직접 입력'} />
                                </label>
                                <label className={'last'}>
                                    <span className={'common-form-input-label'}>
                                        연구분석방법
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input type={'radio'} name={'prps'} value={'과학적연구'} /> 분석공간 이용
                                    <input className={'ml-10'} type={'radio'} name={'prps'} value={'통계작성'} /> 분석포털 이용
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'common-form-button-wrapper'}>
                    <div>
                        <button className={'common-button light'} onClick={goToPrev}>이전</button>
                    </div>
                    <div>
                        <button className={'common-button light'}>임시저장</button>
                        <button className={'common-button primary ml-10'} type="submit" >다음</button>
                    </div>
                </div>
            </div>
        </div>
        </form>
    );
}

export default NcdcRequestForm;
